import { jsonClient } from "../../shared/libs/jsonClient"
import { ChapterRawData } from "./ChapterRawData"

/** viewer/editor データ取得 */
export const callGetChapterRawData = async (
  chapterId: number,
): Promise<ChapterRawData> => {
  try {
    const resp = await jsonClient.request<ChapterRawData>({
      url: `/api/novel/data?chapter_id=${chapterId}`,
      method: "GET",
    })

    return resp.data
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error(error.response)

    if (error.response) {
      return Promise.reject(error.response.data)
    }

    return Promise.reject(error)
  }
}
